// common/index.ts
import bg01 from "./bg-01.png";

const Common = {
  bg01,
};

export default Common;

// 個別エクスポート
export { bg01 };
